// Auto-generated build version
// This file is updated during the build process
export const APP_VERSION = '1.0.0'
export const BUILD_TIMESTAMP = new Date().toISOString()
export const BUILD_DATE = new Date().toLocaleString('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'America/Chicago'
})
